// Test IDs for the home / landing feature.
export const HOME = {
  heroCard: 'home-hero-card',
  heroTitle: 'home-hero-title',
  heroSubtitle: 'home-hero-subtitle',
  heroEnterButton: 'home-hero-enter-button',
  heroProgressBar: 'home-hero-progress-bar',
  heroProgressFill: 'home-hero-progress-fill',
  liveChip: 'home-live-chip',
  contentsSection: 'home-contents-section',
  contentsGrid: 'home-contents-grid',
  segmentCard: (n) => `home-segment-card-${n}`,
  segmentArrowBtn: (n) => `home-segment-arrow-btn-${n}`,
  segmentCheckBtn: (n) => `home-segment-check-btn-${n}`,
  exchangeLinkCard: 'home-exchange-link-card',
  mentorsLinkCard: 'home-mentors-link-card',
  // keep backward compat
  emergentLink: 'home-emergent-link',
};
